import axios from 'axios';

// API�x�[�XURL
const baseURL = process.env.VUE_APP_API_BASE_URL;
// API�^�C���A�E�g�ݒ�
const timeout = process.env.VUE_APP_API_TIMEOUT;
// API�w�b�_�[�ݒ�
const headers = {
    "Content-type": "application/json"
};

// ���ʂ�axios
export default axios.create({
    baseURL,
    headers,
    timeout
});